// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoBlock_container__2yT3C","blockDetail":"InfoBlock_blockDetail__3tasv","title":"InfoBlock_title__2qQQJ","content":"InfoBlock_content__1kSmd"};